import Vue from "vue";
import Vuex from "vuex";
import { phones } from "../data/phones";
import { brands } from "../data/brands";
import { brandFilter } from "../filters/brandFilter";
import { orderByFilter } from "../filters/orderByFilter";
import { phoneTextFilter } from "../filters/phoneTextFilter";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  // state is like property / data
  state: {
    products: phones,
    brands: brands,
    cart: [],
    brandFilter: "",
    orderBy: "",
    textSearch: ""
  },
  // getters is like computed
  getters: {
    cartLength(state) {
      return state.cart.length;
    },
    brandsCount(state) {
      const counts = {};
      state.products.forEach(p => {
        counts[p.brand] = counts[p.brand] + 1 || 1;
      });

      return counts;
    },
    filterProducts(state) {
      debugger;

      const brands = state.brandFilter;
      const orderBy = state.orderBy;
      const textSearch = state.textSearch;

      const filterByBrandArr = brandFilter(state.products, brands);
      const filterByOrderArr = orderByFilter(filterByBrandArr, orderBy);
      const filterByPhoneTextArr = phoneTextFilter(
        filterByOrderArr,
        textSearch
      );

      return filterByPhoneTextArr;
    }
  },
  // mutations is like changes of state/property/data
  mutations: {
    addProductToCart: (state, product) => {
      debugger;
      console.lgo;
      const cartItemIndex = state.cart.findIndex(
        item => item.id === product.id
      );

      if (cartItemIndex < 0) {
        debugger;
        state.cart.push({
          ...product,
          quantity: 1,
          total: 1 * product.price
        });
        debugger;
      } else {
        state.cart[cartItemIndex].quantity++;
        state.cart[cartItemIndex].total =
          state.cart[cartItemIndex].quantity * product.price;
      }
    },
    removeProductFromCart: (state, id) => {
      const cartItemIndex = state.cart.findIndex(item => item.id === id);

      state.cart.splice(cartItemIndex, 1);
    },
    incrementItemQuantity: (state, id) => {
      const cartItemIndex = state.cart.findIndex(item => item.id === id);

      state.cart[cartItemIndex].quantity++;

      state.cart[cartItemIndex].total =
        state.cart[cartItemIndex].quantity * state.cart[cartItemIndex].price;
    },
    decrementItemQuantity: (state, id) => {
      const cartItemIndex = state.cart.findIndex(item => item.id === id);
      if (state.cart[cartItemIndex].quantity === 1) return void 0;
      state.cart[cartItemIndex].quantity--;

      state.cart[cartItemIndex].total =
        state.cart[cartItemIndex].quantity * state.cart[cartItemIndex].price;
    },
    clearCart: state => {
      state.cart = [];
    },
    addBrandToFilter: (state, brand) => {
      if (state.brandFilter.includes(brand)) return void 0;

      state.brandFilter += brand;
    },
    removeBrandFromFilter: (state, brand) => {
      const reg = new RegExp(brand, "gi");
      state.brandFilter = state.brandFilter.replace(reg, "");
    },
    orderByPriceAsc: state => {
      state.orderBy = "asc";
    },
    orderByPriceDesc: state => {
      state.orderBy = "desc";
    },
    searchText: (state, text) => {
      debugger;
      state.textSearch = text;
    }
  },
  actions: {
    addProductToCart: (context, payload) => {
      setTimeout(function() {
        // reach out for data
        context.commit("addProductToCart", payload);
      }, 1000);
    },
    removeProductFromCart: (context, id) => {
      setTimeout(function() {
        // reach out for data
        context.commit("removeProductFromCart", id);
      }, 1000);
    },
    incrementItemQuantity: (context, id) => {
      setTimeout(function() {
        // reach out for data
        context.commit("incrementItemQuantity", id);
      }, 1000);
    },
    decrementItemQuantity: (context, id) => {
      setTimeout(function() {
        // reach out for data
        context.commit("decrementItemQuantity", id);
      }, 1000);
    }
  },
  modules: {}
});
